// --- SaniQ ---
import {Role} from "../../../../../models/Role";
import * as RolesConstants from '../constants';

interface RolesState {
  hasLoaded: boolean;
  isLoading: boolean;
  collection: Role[];
}

const initialState: RolesState = {
  hasLoaded: false,
  isLoading: false,
  collection: []
};

export function roles(state = initialState, action): RolesState {
  switch (action.type) {
    case RolesConstants.ROLES_FETCH_STARTED:
      return {...state, isLoading: true, collection: []};
    case RolesConstants.ROLES_FETCH_COMPLETED:
      return {...state, isLoading: false, collection: action.roles, hasLoaded: true};
    default:
      return state;
  }
}
